var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: {}, attrs: { gutter: _vm.config.gutter } },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.config.span } },
        [
          _c(
            "el-card",
            {
              class: _vm.config.borderClass,
              attrs: { shadow: _vm.config.shadow }
            },
            [
              _c("div", { staticClass: "panel-title" }, [
                _vm._v(_vm._s(_vm.$t(_vm.config.name)))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "file-radio" }, [
                _vm.config.select
                  ? _c(
                      "span",
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(_vm.config.select.label)) +
                            "\n          "
                        ),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "220px" },
                            attrs: {
                              disabled: _vm.config.select.disabled,
                              clearable:
                                _vm.config.select.clearable === false
                                  ? _vm.config.select.clearable
                                  : true,
                              filterable: _vm.config.select.filterable,
                              placeholder: _vm.config.select.placeholder
                            },
                            on: {
                              change: function($event) {
                                return _vm.handleEvent(
                                  _vm.config.select.event,
                                  _vm.config.select.value
                                )
                              }
                            },
                            model: {
                              value: _vm.config.select.value,
                              callback: function($$v) {
                                _vm.$set(_vm.config.select, "value", $$v)
                              },
                              expression: "config.select.value"
                            }
                          },
                          _vm._l(_vm.config.select.list, function(
                            childItem,
                            childIndex
                          ) {
                            return _c("el-option", {
                              key: childIndex,
                              attrs: {
                                label: childItem.key,
                                value: childItem.value
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.config.datePicker
                  ? _c(
                      "span",
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(_vm.config.datePicker.label)) +
                            "\n          "
                        ),
                        _c("el-date-picker", {
                          attrs: {
                            "value-format": "yyyy-MM-dd",
                            format: "yyyy-MM-dd",
                            type: "date",
                            disabled: _vm.config.datePicker.disabled,
                            align: "right",
                            "default-value": new Date(),
                            "picker-options": _vm.pickerOptions
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleClick(
                                _vm.config.datePicker.orderDateEvent,
                                _vm.config.datePicker.value
                              )
                            }
                          },
                          model: {
                            value: _vm.config.datePicker.value,
                            callback: function($$v) {
                              _vm.$set(_vm.config.datePicker, "value", $$v)
                            },
                            expression: "config.datePicker.value"
                          }
                        }),
                        _vm._v(" "),
                        _vm.config.input
                          ? [
                              _c(
                                "span",
                                { staticStyle: { color: "#C03639" } },
                                [_vm._v(_vm._s(_vm.$t(_vm.config.input.label)))]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "280px" },
                                attrs: { disabled: _vm.config.input.disabled },
                                model: {
                                  value: _vm.config.input.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.config.input, "value", $$v)
                                  },
                                  expression: "config.input.value"
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.config.type === "file"
                ? void 0
                : _vm.config.type !== "image"
                ? [
                    _c("el-alert", {
                      attrs: {
                        closable: false,
                        title: _vm.$t("excel.tip"),
                        type: "success"
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { size: "mini" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.config.type != "image"
                            ? _vm.$t("upload.fileUpload")
                            : ""
                      }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            action: _vm.config.action,
                            "list-type": _vm.config.listType,
                            multiple: _vm.config.multiple,
                            limit: _vm.config.limit,
                            "file-list": _vm.config.fileList,
                            "before-upload": _vm.beforeUpload,
                            "on-preview": _vm.onPreview,
                            "on-success": _vm.onSuccess,
                            "on-remove": _vm.onRemove,
                            "on-error": _vm.onError,
                            accept: _vm.config.accept,
                            "auto-upload": _vm.config.autoUpload,
                            headers: { Authorization: _vm.token }
                          }
                        },
                        [
                          _vm.config.type == "image"
                            ? [
                                _c("el-image", {
                                  ref: "preImg",
                                  staticStyle: { width: "1px", height: "1px" },
                                  attrs: {
                                    src: "@/assets/images/logo.png",
                                    "preview-src-list": _vm.imagePrelist
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-plus",
                                  attrs: { slot: "default" },
                                  slot: "default"
                                }),
                                _vm._v(" "),
                                _vm._v(" "),
                                _vm.config.type != "image"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "el-upload__tip",
                                        attrs: { slot: "tip" },
                                        slot: "tip"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("image.tip")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm.config.type == "file"
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "small",
                                      disabled: _vm.config.disabled,
                                      type: "primary"
                                    },
                                    slot: "trigger"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.chioseFile")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "margin-top": "-10px"
                                    },
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      disabled: _vm.config.disabled
                                    },
                                    on: { click: _vm.submitUpload }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.send")))]
                                )
                              ]
                            : [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "small",
                                      disabled: _vm.config.disabled,
                                      type: "primary"
                                    },
                                    slot: "trigger"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.chioseFile")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "margin-top": "-10px"
                                    },
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      disabled: _vm.config.disabled
                                    },
                                    on: { click: _vm.submitUpload }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.send")))]
                                ),
                                _vm._v(" "),
                                _vm.config.templateShow != "show"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "el-upload__tip",
                                        attrs: { slot: "tip" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClick(
                                              _vm.config.templateEvent
                                            )
                                          }
                                        },
                                        slot: "tip"
                                      },
                                      [
                                        _c(
                                          "el-link",
                                          {
                                            staticStyle: {
                                              color: "#06c",
                                              "font-size": "13px"
                                            },
                                            attrs: {
                                              href: "#",
                                              type: "success"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("upload.downTemplate")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("image", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66afef91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66afef91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload.vue
// module id = null
// module chunks = 